import { defineMessages } from 'react-intl';

export default defineMessages({
  clearFiltersButton: {
    id: 'designOptionFilters.clearFiltersButton',
    description: 'Clear filters button',
    defaultMessage: 'Clear And Continue',
  },
  cancelButton: {
    id: 'designOptionFilters.cancelButton',
    description: 'Cancel clear filters button',
    defaultMessage: 'Cancel',
  },
  warningTitle: {
    id: 'designOptionFilters.clearFiltersTitle',
    description: 'Clear filters warning title',
    defaultMessage: 'Clear all filters within a group?',
  },
  warningMessage: {
    id: 'designOptionFilters.clearFiltersMessage',
    description: 'Clear filters warning message',
    defaultMessage:
      'Performing a global search or applying any changes to it, will result in clearing all filters applied within functional groups. Are you sure you want to continue?',
  },
});
